import store from '@/store'
import { getBroadcastChannel } from './index'
import cloneDeep from 'lodash/cloneDeep'

const broadcastEvents = {
    RENDER_BROADCAST_MESSAGE: 'RENDER_BROADCAST_MESSAGE',
    CLEAR_CHATS_ACROSS_TABS: 'CLEAR_CHATS_ACROSS_TABS',
    HANDLE_FORM_CONTROLS_ACROSS_TABS: 'HANDLE_FORM_CONTROLS_ACROSS_TABS',
    HANDLE_FORM_SUBMISSION_ACROSS_TABS: 'HANDLE_FORM_SUBMISSION_ACROSS_TABS',
    HANDLE_FORM_CONTROLS_CLICKED_ACROSS_TABS: 'HANDLE_FORM_CONTROLS_CLICKED_ACROSS_TABS'
}

const actionUtil = {
    renderUserMessage(data) {
        store.dispatch('renderBroadcastMessage', data)
    },
    broadcastEndChat(data) {
        store.dispatch('endChatAcrossTabs', data)
    },
    handleFormControls(data) {
        store.dispatch('updateShowFormControls', data)
    },
    handleFormControlsClicked(data) {
        store.dispatch('updateFormControlsClicked', data)
    },
    handleFormSubmission(data) {
        store.dispatch('updateLastFormSubmission', {...data, updateAcrossTabs: true})
    }
}

export const dispatchActionOnBroadcast = () => {
    return {
        [broadcastEvents.RENDER_BROADCAST_MESSAGE]: actionUtil.renderUserMessage,
        [broadcastEvents.CLEAR_CHATS_ACROSS_TABS]: actionUtil.broadcastEndChat,
        [broadcastEvents.HANDLE_FORM_CONTROLS_ACROSS_TABS]: actionUtil.handleFormControls,
        [broadcastEvents.HANDLE_FORM_SUBMISSION_ACROSS_TABS]: actionUtil.handleFormSubmission,
        [broadcastEvents.HANDLE_FORM_CONTROLS_CLICKED_ACROSS_TABS]: actionUtil.handleFormControlsClicked
    }
}

export function acceptBroadcastMessage(messageRequestBody) {
    const messageEvent = {type: broadcastEvents.RENDER_BROADCAST_MESSAGE, data: messageRequestBody}
    postMessageAcrossTabs(messageEvent)
}

export function endChatsAcrossTabs(data) {
    const messageEvent = {type: broadcastEvents.CLEAR_CHATS_ACROSS_TABS, data}
    postMessageAcrossTabs(messageEvent)
} 

export function handleFormControlsVisibilityAcrossTabs(data) {
    const messageEvent = {type: broadcastEvents.HANDLE_FORM_CONTROLS_ACROSS_TABS, data}
    postMessageAcrossTabs(messageEvent)

}

export function handleFormSubmissionAcrossTabs(form) {
    const messageEvent = {type: broadcastEvents.HANDLE_FORM_SUBMISSION_ACROSS_TABS, data: form}
    postMessageAcrossTabs(messageEvent)
}

export function handleFormControlsClickedAcrossTabs(data) {
    const messageEvent = {type: broadcastEvents.HANDLE_FORM_CONTROLS_CLICKED_ACROSS_TABS, data}
    postMessageAcrossTabs(messageEvent)
}

const postMessageAcrossTabs = (messageEvent) => {
    const channel = getBroadcastChannel()
    channel && channel.postMessage(cloneDeep(messageEvent))
}
